
import React from 'react';
import { Rental } from '@/services/types';
import { RentalDetailsDialog } from './RentalDetailsDialog';
import { AddRentalDialog } from './AddRentalDialog';
import { EditRentalDialog } from './EditRentalDialog';
import { DeleteRentalDialog } from './DeleteRentalDialog';

interface RentalDialogsProps {
  selectedRental: Rental | null;
  showAddDialog: boolean;
  showDetailsDialog: boolean;
  showEditDialog: boolean;
  showDeleteDialog: boolean;
  setShowAddDialog: (show: boolean) => void;
  setShowDetailsDialog: (show: boolean) => void;
  setShowEditDialog: (show: boolean) => void;
  setShowDeleteDialog: (show: boolean) => void;
  handleAddRental: (event: React.FormEvent<HTMLFormElement>) => Promise<void>;
  handleEditRental: (data: any) => Promise<boolean>;
  handleDeleteRental: () => void;
  handleChangeStatus: (status: Rental['status']) => Promise<void>;
  handleRentalUpdate: () => void;
  setIsFormOpen?: (isOpen: boolean) => void;
  loading: boolean;
  bikes: any[];
  couriers: any[];
}

export const RentalDialogs: React.FC<RentalDialogsProps> = ({
  selectedRental,
  showAddDialog,
  showDetailsDialog,
  showEditDialog,
  showDeleteDialog,
  setShowAddDialog,
  setShowDetailsDialog,
  setShowEditDialog,
  setShowDeleteDialog,
  handleAddRental,
  handleEditRental,
  handleDeleteRental,
  handleChangeStatus,
  handleRentalUpdate,
  setIsFormOpen,
  loading,
  bikes,
  couriers
}) => {
  return (
    <>
      {/* Диалог добавления аренды */}
      <AddRentalDialog
        open={showAddDialog}
        onOpenChange={setShowAddDialog}
        onSubmit={handleAddRental}
        loading={loading}
        couriers={couriers}
        bikes={bikes}
      />

      {/* Диалог просмотра деталей аренды */}
      {selectedRental && (
        <RentalDetailsDialog
          rental={selectedRental}
          open={showDetailsDialog}
          onOpenChange={setShowDetailsDialog}
          onEdit={() => setShowEditDialog(true)}
          onDelete={() => setShowDeleteDialog(true)}
          onStatusChange={handleChangeStatus}
          onRentalUpdate={handleRentalUpdate}
          loading={loading}
        />
      )}

      {/* Диалог редактирования аренды */}
      {selectedRental && (
        <EditRentalDialog
          rental={selectedRental}
          open={showEditDialog}
          onOpenChange={setShowEditDialog}
          onSubmit={handleEditRental}
          loading={loading}
          bikes={bikes}
          couriers={couriers}
          setIsFormOpen={setIsFormOpen}
        />
      )}

      {/* Диалог удаления аренды */}
      {selectedRental && (
        <DeleteRentalDialog
          rental={selectedRental}
          open={showDeleteDialog}
          onOpenChange={setShowDeleteDialog}
          onConfirm={handleDeleteRental}
          loading={loading}
        />
      )}
    </>
  );
};
